import { render, staticRenderFns } from "./location_products.vue?vue&type=template&id=e7996ae6&scoped=true&"
import script from "./location_products.vue?vue&type=script&lang=js&"
export * from "./location_products.vue?vue&type=script&lang=js&"
import style0 from "./location_products.vue?vue&type=style&index=0&id=e7996ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7996ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7996ae6')) {
      api.createRecord('e7996ae6', component.options)
    } else {
      api.reload('e7996ae6', component.options)
    }
    module.hot.accept("./location_products.vue?vue&type=template&id=e7996ae6&scoped=true&", function () {
      api.rerender('e7996ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/location_modal/tabs/location_products.vue"
export default component.exports